import { Tooltip } from 'antd';
import './GenericCard.less';
import { ContextApp } from '../../../contexts/ContextApp';
import { useContext } from 'react';

interface IContactCardProps {
  icon: JSX.Element;
  title?: string | JSX.Element | undefined;
  description: string | JSX.Element;
  button?: JSX.Element;
  className?: string;
  orientation?: 'horizontal' | 'vertical';
  onCardClick?: () => void;
  showEditIcon?: boolean;
  onEditClick?: () => void;
}

export const GenericCard = (props: IContactCardProps) => {
  const {
    icon,
    title,
    description,
    button,
    className,
    orientation = 'horizontal',
    onCardClick,
    showEditIcon = false,
    onEditClick,
  } = props;

  const { t } = useContext(ContextApp);

  return (
    <div className={`GenericCard-container ${className}`} onClick={onCardClick}>
      <div>
        <div
          className="GenericCard-container--information"
          style={{
            flexDirection: orientation === 'horizontal' ? 'row' : 'column',
            alignItems: orientation === 'horizontal' ? 'center' : 'flex-start',
          }}
        >
          {icon}
          <div className="GenericCard-container--information--head">
            {title ? <p className="GenericCard-container--information--title">{title}</p> : null}
          </div>
          <div className='GenericCard-container--information--icon'>
            {showEditIcon && (
              <Tooltip
                key="edit_card"
                title={`${t('action.modify')}`}
              >
                <span
                  translate="no"
                  className="material-symbols-outlined pointer appSetting-action-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    onEditClick?.();
                  }}
                >
                  edit
                </span>
              </Tooltip>
            )}
          </div>
        </div>
        <div className="GenericCard-container--information--description">
          <p >
            {description}
          </p>
        </div>
      </div>
      {button}
    </div>
  );
};
